<template>
    <div class="multiple-chained-select-wrapper">
      <div class="multiple-chained-select-header">
          <div class="dropdown-header-wrapper__reset-link">
              <a href @click.prevent="reset" >
                  <font-awesome-icon :icon="['fal', 'info-circle']" class="fa fa-fw" /> Having trouble choosing your store? Click here to refresh the store picker.
              </a>
          </div>
      </div>
      <div class="multiple-chained-select-body">

          <div class="dropdown-wrapper">

              <div class="dropdown-wrapper__header">
                  <span v-if="pending" class="small text-muted">
                      <font-awesome-icon :icon="['fal', 'cog']" spin class="fa fa-fw" />
                      Loading
                  </span>
              </div>

              <div class="mb-3">
                  <label>Select State</label>
                  <multiselect
                      :value="selectionState.value"
                      :options="selectionState.options"
                      placeholder="Select one or search"
                      label="state"
                      track-by="state"
                      @select="storeStateSelected"
                      :allowEmpty="false"
                      deselectLabel=""
                  ></multiselect>
              </div>

              <div class="mb-3">
                  <label>Select City</label>
                  <multiselect
                      :value="selectionCity.value"
                      :options="selectionCity.options"
                      placeholder="Select one or search"
                      label="city"
                      track-by="city"
                      :disabled="getCityDisabledState"
                      @select="storeCitySelected"
                      :allowEmpty="false"
                      deselectLabel=""
                  ></multiselect>
              </div>

              <div>
                  <label>Select Store</label>
                  <!-- :custom-label="storeCustomLabel" -->
                  <multiselect
                      :value="selectionStore.value"
                      :options="selectionStore.options"
                      placeholder="Select one or search"
                      label="id"

                      track-by="id"
                      :disabled="getStoreDisabledState"
                      :option-height="70"
                      :show-labels="false"
                      @select="storeStoreSelected">

                          <span slot="noResult">
                              Sorry, no stores were found. Please choose another city.
                          </span>

                          <template slot="singleLabel" slot-scope="props">
                              <span class="option__description">
                                  <div class="option__title">
                                      {{ props.option.name }}
                                  </div>
                                  <span class="option__info">
                                      {{ storeCustomLabel(props.option) }}
                                  </span>
                              </span>
                          </template>

                          <template slot="option" slot-scope="props">
                              <div class="option__description">
                                  <div class="option__title">
                                      {{ props.option.name }}
                                  </div>
                                  <span class="option__info">
                                      {{ storeCustomLabel(props.option) }}
                                  </span>
                              </div>
                          </template>

                  </multiselect>
              </div>
              <div class="google-review" v-if="placeId">
                <div class="google-review-desc">
                  <font-awesome-icon :icon="['fal', 'info-circle']" class="fa fa-fw" /> After submitting the Google store review, please return to this page to complete your submission.
                </div>
                <a @click.prevent="revsubmit(placeId)" :href="'https://search.google.com/local/writereview?placeid=' + placeId" class="btn btn-tan" target="_blank">Go To Google Store Review </a>
              </div>

          </div>

          <div class="store-display-wrapper">
              <div class="store-display-wrapper__top">
                  <transition name="bounceUp" mode="out-in" :duration="{ enter: 850, leave: 850 }">
                      <img v-if="selectedStore" :key="1" src="@/assets/images/utilities/check.png" class="img-fluid store-display-wrapper__top__indicator-icon-image" alt="Check">

                      <img v-if="!selectedStore" :key="2" src="@/assets/images/utilities/map-pin.png" class="img-fluid store-display-wrapper__top__indicator-icon-image" alt="Map Pin">
                  </transition>
              </div>

              <div class="store-display-wrapper__bottom">
                  <transition name="fade" mode="out-in" :duration="{ enter: 850, leave: 850 }">

                      <div v-if="selectedStore" :key="1" class="store-display-wrapper__bottom__wrapper">
                          <div class="store-display-wrapper__bottom__wrapper__your-selected-store">
                              Your Selected Store:
                          </div>

                          <div class="store-display-wrapper__bottom__wrapper__store-text">
                              {{this.concatSelectedStoreInfo}}
                          </div>

                          <div class="store-display-wrapper__bottom__wrapper__reset-link" style="font-size:0.7rem">
                              <a href @click.prevent="reset" >
                                  <font-awesome-icon :icon="['fal', 'info-circle']" class="fa fa-fw" /> Having trouble choosing your store? Click here to refresh the store picker.
                              </a>
                          </div>
                      </div>

                      <div v-if="!selectedStore" :key="4" style="font-size:0.7rem">
                          <font-awesome-icon :icon="['fal', 'info-circle']" class="fa fa-fw" /> Use the dropdowns to choose your store.
                      </div>

                  </transition>
              </div>
          </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'

export default {
    name: 'multiple-chained-select',
    props: [],
    data: function () {
        return {
            pending: false
        }
    },
    computed: {
        ...mapState({
            selectionState: state => state.multipleChainedSelect.selectionState,
            selectionCity: state => state.multipleChainedSelect.selectionCity,
            selectionStore: state => state.multipleChainedSelect.selectionStore,
            selectedStore: state => state.multipleChainedSelect.selectedStore,
            placeId: state => state.multipleChainedSelect.placeId

        }),

        getCityDisabledState () {
            if (this.selectionState.value) {
                return false
            }

            return true
        },
        getStoreDisabledState () {
            if (this.selectionState.value && this.selectionCity.value) {
                return false
            }

            return true
        },

        concatSelectedStoreInfo () {
            if (this.selectedStore) {
                return this.selectedStore.name + ' - ' + this.selectedStore.address + ' ' + ((this.selectedStore.address2) ? this.selectedStore.address2 + ' ' : ' ') + this.selectedStore.city + ' ' + this.selectedStore.state + ' ' + this.selectedStore.postal
            }
            return ''
        }
    },
    methods: {
        async init () {
            this.pending = true
            try {
                await this.$store.dispatch('multipleChainedSelect/reset')
            } catch (error) {
                // Error
            } finally {
                this.pending = false
            }
        },
        async revsubmit (placeId) {
            if(this.$parent.$v.entryFormData.nameF.$invalid || this.$parent.$v.entryFormData.nameL.$invalid || this.$parent.$v.entryFormData.email.$invalid || this.$parent.$v.entryFormData.location.$invalid) {
                this.$parent.$v.entryFormData.nameF.$touch()
                this.$parent.$v.entryFormData.nameL.$touch()
                this.$parent.$v.entryFormData.email.$touch()
                this.$parent.$v.entryFormData.location.$touch()
                this.$toasted.error('Please enter the required fields.')
                return
            } else {
                window.open("https://search.google.com/local/writereview?placeid=" + placeId, "_blank")

                // Set Entry Type
                this.$parent.entryFormData.entry_type = 'google-review'

                // Set multipleChainedSelect selectedStore to the form's store
                this.$parent.entryFormData.storeObject = this.selectedStore
                this.$parent.entryFormData.storeId = this.selectedStore.id
                this.$parent.entryFormData.storeInfo = this.selectedStore.name + ' ' + this.selectedStore.address
                this.$parent.entryFormData.storeCity = this.selectedStore.city
                this.$parent.entryFormData.storeState = this.selectedStore.state
                await this.$parent.$store.dispatch('enter/enter', this.$parent.entryFormData)
            }
            // if (this.$v.$invalid) {
            //     this.$v.$touch()
            //     this.$toasted.error('Please complete all fields.')
            //     return
            // }
        },
        // API calls
        async getStates () {
            this.pending = true
            try {
                await this.$store.dispatch('multipleChainedSelect/getStates')
            } catch (error) {
                // Error
            } finally {
                this.pending = false
            }
        },
        async getCities () {
            this.pending = true
            try {
                await this.$store.dispatch('multipleChainedSelect/getCities', this.selectionState.value)
            } catch (error) {
                // Error
            } finally {
                this.pending = false
            }
        },
        async getStores () {
            this.pending = true
            try {
                await this.$store.dispatch('multipleChainedSelect/getStores', {state: this.selectionState.value.state, city: this.selectionCity.value.city_slug})
            } catch (error) {
                // Error
            } finally {
                this.pending = false
            }
        },
        async getPlaceId () {
            this.pending = true
            try {
                await this.$store.dispatch('multipleChainedSelect/getPlaceId', {selectedStore: this.selectedStore})
            } catch (error) {
                // Error
            } finally {
                this.pending = false
            }
        },

        // Selection events
        async storeStateSelected (e) {
            await this.$nextTick()
            await this.$store.dispatch('multipleChainedSelect/updateStatesValue', e)
            this.getCities()
        },
        async storeCitySelected (e) {
            await this.$nextTick()
            await this.$store.dispatch('multipleChainedSelect/updateCitiesValue', e)
            this.getStores()
        },
        async storeStoreSelected (e) {
            await this.$nextTick()
            await this.$store.dispatch('multipleChainedSelect/updateStoresValue', e)

            this.$store.commit('multipleChainedSelect/ADD_SELECTED_STORE', e)
            this.getPlaceId()
            //this.$store.commit('multipleChainedSelect/ADD_PLACE_ID', e)
        },

        // Custom Label
        storeCustomLabel (store) {
            return store.address + ' ' + ((store.address2) ? store.address2 + ' ' : ' ') + store.city + ' ' + store.state + ' ' + store.postal
        },

        // Reset
        reset () {
            this.init()
        },

        // Tabindex fix
        tabIndexFix () {
            let el1 = this.$el.getElementsByClassName("multiselect")[0]
            let el2 = this.$el.getElementsByClassName("multiselect")[1]
            let el3 = this.$el.getElementsByClassName("multiselect")[2]
            if (el1 && el2 && el3) {
                el1.tabIndex = 0
                el2.tabIndex = 0
                el3.tabIndex = 0
            }
        }
    },
    mounted () {
        this.init()
        this.tabIndexFix()
    },
    components: {
        Multiselect
    }
}
</script>

<style lang="scss">
    @import '~@/assets/css/app.scss';

    $wrapper-border-color: darken(#eee, 5%);
    $wrapper-border-radius: 6px;

    .multiple-chained-select-wrapper {
      background: $white;
      height: auto;
      height: 100%;
      width: 100%;
      display: flex;
      flex-direction: column;
      border-radius: $wrapper-border-radius;
      box-shadow: 2px 5px 8px 0 rgba($black, 0.1);

      .google-review {
        margin-top: 20px;
        margin-bottom: 20px;

        .google-review-desc {
          font-size: 0.8rem;
          margin-bottom: 10px;
        }
      }

      .multiple-chained-select-header {
        width: 100%;
        padding: 0 20px;

        .dropdown-header-wrapper {
            &__reset-link {
                font-size: 0.7rem;
                color: $black;

                a {
                  color: $dark-grey !important;
                }
            }
        }
      }
      .multiple-chained-select-body {
          background: transparent;
          height: auto;
          height: 100%;
          width: 100%;
          display: flex;
          padding: 20px;
          flex-direction: column;

          @media (min-width: 992px) {
              flex-direction: row;
          }

          .dropdown-wrapper {
              width: 100%;
              height: auto;
              padding-right: 20px;

              @media (min-width: 992px) {
                  width: 50%;
                  padding-right: 20px;
              }

              &__header {
                  font-size: 1.2rem;
                  line-height: 1.6;
                  margin-bottom: 5px;
                  font-weight: bold;
              }

              &__reset-link {
                  font-size: 0.8rem;
                  color: $blue;
                  margin-bottom: 20px;
              }
          }

          .store-display-wrapper {
              width: 100%;
              min-height: 300px;
              background: #eee;
              display: flex;
              flex-direction: column;

              @media (min-width: 992px) {
                  width: 50%;
                  border-left: 0;
              }

              &__top {
                  height: 50%;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  background-image: url('~@/assets/images/utilities/blurred-background.jpg');
                  background-size: cover;
                  background-repeat: no-repeat;
                  background-position: center center;
                  padding: 20px;

                  @media (min-width: 992px) {

                  }

                  &__indicator-icon-image {
                      //nasty flexbox image ie10 issue https://github.com/philipwalton/flexbugs/issues/75
                      //forcing me to use max-width
                      max-width: 75px;
                      max-height: 75px;
                  }
              }

              &__bottom {
                  height: 50%;
                  padding: 20px 20px 5px 20px;

                  &__wrapper {
                      height: 100%;
                      display: flex;
                      flex-direction: column;

                      &__your-selected-store {
                          margin-bottom: 10px;
                      }

                      &__store-text {
                          font-size: 1.2rem;
                          margin-bottom: 20px;

                          @media (min-width: 992px) {
                              margin-bottom: 0;
                          }
                      }

                      &__reset-link {
                          margin-top: auto;
                          font-size: 0.8rem;
                          color: $blue;
                          margin-bottom: 20px;
                      }
                  }
              }
          }
      }
    }

    .multiselect {

      margin-bottom: 20px;

        &__input {
        }

        &__tags {
            border: 1px solid rgba($black, 0.3);
        }

        &__select {
          background: transparent !important;
        }

        &__element {
            border-bottom: 1px solid lighten($light-grey, 5%);

            .option__description {
                height: 70px;
                line-height: 1.4;

            }

            .option__title {
                whitespace: unset;
                font-size: 1.2rem;
            }

            .option__info {
                font-size: 0.9rem;
            }

            .noResult {
                line-height: 1.4;
            }
        }
    }
</style>
